import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import request from '@src/utils/request'
import { getUserInfo } from '@src/api/user'

// 定义用户状态接口
interface UserState {
	name: string
	nickname: string
	tenantName: string
	token: string
	role: string
	profile: string
	fetchUserInfo: () => Promise<void>
	logout: () => void
}
const userStore = create<UserState>()(
	persist(
		(set, get) => ({
			name: '',
			nickname: '',
			tenantName: '',
			token: '',
			refreshToken: '',
			role: '',
			profile: '',
			fetchUserInfo: async () => {
				const res = await getUserInfo()
				const { name, nickname, tenantName, token, role, profile } = res.data
				set({
					name,
					nickname,
					tenantName,
					token,
					role,
					profile
				})
			},
			logout: () =>
				set({
					name: '',
					nickname: '',
					tenantName: '',
					token: '',
					role: '',
					profile: ''
				})
		}),
		{
			name: 'userStorage', // 存储中的项目名称，必须是唯一的
			storage: createJSONStorage(() => sessionStorage) // 使用sessionStorage作为存储
		}
	)
)

export default userStore
